import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { alpha } from '@mui/material/styles';
import { IconButton, type IconButtonProps } from '@/primitives';
import { blue } from '@/lib/colours';
import { toSxArray } from '@/lib/sx';

/** Translucent blue used for icon-only back (database search animal details style, without label). */
const searchStyleBackButtonSx = {
  borderRadius: 2,
  backgroundColor: alpha(blue[500], 0.3),
  color: 'inherit',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: alpha(blue[500], 0.2),
    boxShadow: 'none',
  },
} as const;

export type BackButtonProps = IconButtonProps & {
  /** Smaller hit target and icon. */
  compact?: boolean;
  /**
   * Icon-only; same colours as the database search animal details back control (no text).
   */
  searchStyle?: boolean;
};

export function BackButton({
  compact,
  searchStyle,
  sx,
  ...props
}: BackButtonProps) {
  if (searchStyle) {
    const dim = compact ? 32 : 40;
    const iconSize = compact ? 18 : 22;
    return (
      <IconButton
        sx={[
          searchStyleBackButtonSx,
          {
            width: dim,
            height: dim,
            padding: compact ? '6px' : '8px',
          },
          ...toSxArray(sx),
        ]}
        {...props}
      >
        <ArrowBackIcon sx={{ fontSize: iconSize }} />
      </IconButton>
    );
  }

  return (
    <IconButton
      sx={[
        {
          backgroundColor: blue[150],
          color: blue[600],
          height: compact ? 30 : 40,
          width: compact ? 30 : 40,
          padding: compact ? '4px' : undefined,
        },
        ...toSxArray(sx),
      ]}
      {...props}
    >
      <ArrowBackIcon sx={{ fontSize: compact ? 18 : 24 }} />
    </IconButton>
  );
}
